export default {
	/**
     * The request data was lower than 8 people participate,
     * so the server not allow to view it.
     */
	NOT_ENOUGH_DATA: 403,
	NOT_FOUND: 404,
	SERVER_ERROR: 500,
};


// WEBPACK FOOTER //
// ./src/constants/errorStatus.js